<template>
  <div class="shop-order-list">
    <div>
      <ShopCartListDiscount
        v-for="entry of discountEntries"
        :key="`cart-entry-${entry?.id}`"
        :data="entry"
        :is-discount="true"
      />

      <ShopCartListEntry
        v-for="entry of productEntries"
        :key="`cart-entry-${entry?.id}`"
        :data="entry"
      />
    </div>

    <div v-if="isEmpty" key="cart-empty" class="shop-order-list__empty">
      {{ useTranslation('general', 'cart_empty') }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Array,
        default: () => [],
    },
});

const cartStore = useCartStore();
const isEmpty = computed(() => cartStore.isEmpty);

const productEntries = computed(() => props.data.filter((entry) => !entry.is_discount));
const discountEntries = computed(() => props.data.filter((entry) => entry.is_discount));
</script>

<style lang="scss" scoped>
.shop-order-list {
    @include fluid('margin-bottom', 12px, 20px);
}
.shop-order-list__empty {
    @include typo-size('p');
    @include typo-font('regular');

    padding: 20px 0;
    border-top: 2px solid $C_GREY_LIGHT;
    border-bottom: 2px solid $C_GREY_LIGHT;
    text-align: center;
}
</style>
